var _excluded = ["clearable", "onClear", "onMouseOver", "onMouseOut", "size", "appearance", "leftIcon", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Box } from "../box";
import { Columns } from "../columns";
import { Palette, Tone, Size, Appearance } from "./Chip.types";
import { BaseChip } from "./BaseChip";
import { ClickableHoverableWrapper } from "./ClickableHoverableWrapper";
import { ChipLeftIcon, ClickableIcon } from "./ChipIcon";
export var ClearableChip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _clearable = _ref.clearable,
      onClear = _ref.onClear,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? Size.medium : _ref$size,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? Appearance.solid : _ref$appearance,
      leftIcon = _ref.leftIcon,
      children = _ref.children,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ClickableHoverableWrapper, {
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, /*#__PURE__*/React.createElement(BaseChip, _extends({
    ref: ref
  }, others, {
    size: size,
    tone: Tone.light,
    palette: Palette.neutral,
    appearance: appearance
  }), /*#__PURE__*/React.createElement(Columns, {
    align: "left",
    alignY: "center",
    space: "xxSmall",
    wrap: false
  }, leftIcon ? /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(ChipLeftIcon, {
    icon: leftIcon,
    palette: Palette.neutral,
    size: size
  })) : null, /*#__PURE__*/React.createElement(Box, null, children), /*#__PURE__*/React.createElement(ClickableIcon, {
    icon: "cross_circle",
    size: size,
    palette: Palette.neutral,
    onClick: onClear
  }))));
});